import { render } from "./ModulePortfolio.vue?vue&type=template&id=fe4e1e9a"
import script from "./ModulePortfolio.vue?vue&type=script&lang=js"
export * from "./ModulePortfolio.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__